module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.f94b2ad6.mp3";